<template>
  <div class="detail-container">
    <h1>空気環境測定基準値情報詳細</h1>
    <div v-if="measure_std">
      <table class="table table-bordered">
        <tr>
          <th>測定種別</th>
          <td>{{ measure_std.m_measure_type?.measure_type_nm }}</td>
        </tr>
        <tr>
          <th>最小/最大</th>
          <td>{{ measure_std.min_max_type === 0 ? '最低' : '最大' }}</td>
        </tr>
        <tr>
          <th>基準値</th>
          <td>{{ measure_std.std_val }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'MeasureStdList', params: { id: measure_std.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="isAdmin" :to="{ name: 'MeasureStdEdit', params: { id: measure_std.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      空気環境測定基準値情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getMeasureStd } from '@/api/axios';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('空気環境測定基準値情報詳細');
    const store = useStore();

    watchEffect(() => {
      document.title = title.value;
    });

    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));
    const measure_std = ref({});
    const route = useRoute();
    const measureStdId = route.params.id;

    const fetchMeasureStd = async () => {
      const response = await getMeasureStd(measureStdId);
      measure_std.value = response.data;
    };

    onMounted(fetchMeasureStd);

    return {
      title,
      isAdmin,
      measure_std
    };
  }
};
</script>

<style scoped>
.detail-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
